import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { NumberPipe } from './number.pipe'
import { SessionService } from '../services/session/session.service'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  private pipe

  MINUTES = 60
  HOURS = 60 * this.MINUTES

  constructor(@Inject(LOCALE_ID) locale: string, session: SessionService) {
    this.pipe = new NumberPipe(locale, session)
  }

  transform(value: number, options = {}): string {
    if(isNaN(value)){
      throw invalidPipeArgumentError('duration', value)
    }
    
    if (value == null) {
      return 'n/a'
    }

    if (value < 0) {
      return '0s'
    }

    const opts = { include: ['h', 'm', 's'], ...options }

    const include = opts['include']
    let result = ''
    let hours = 0, minutes = 0, seconds = 0
    if (include.some(el => el === 'h')) {
      hours = include.some(el => el === 'm') ? Math.floor(value / this.HOURS) : Math.round(value / this.HOURS)
      value %= this.HOURS
      if (hours > 0) {
        result += this.pipe.transform(hours) + 'h '
      }
    }
    if (include.some(el => el === 'm')) {
      minutes = include.some(el => el === 's') ? Math.floor(value / this.MINUTES) : Math.round(value / this.MINUTES)
      value %= this.MINUTES
      if (hours > 0 || minutes > 0) {
        result += this.pipe.transform(minutes) + 'm '
      }
    }
    if (hours < 10 && include.some(el => el === 's')) {
      seconds = Math.round(value)
      result += this.pipe.transform(seconds) + 's'
    }
    return result.trim()
  }
}
